import mutations from './mutations';
import { DataService } from '@/config/dataService/dataService';
import { notification } from 'ant-design-vue';

const state = () => ({
    data: [],
    loading: false,
    totalRecords: 0,
});

const actions = {
    async segmentAdd({ commit }, payload) {
        commit('segmentAddBegin');
        await DataService.post('/segments', payload).then(response => {
            commit('segmentAddSuccess', response.data.data);

            notification.success({
                message: response.data.message,
                placement: 'topRight'
            });
        }
        ).catch(err => {
            commit('segmentAddError', err);
            console.log(err);
            notification.error({
                message: 'Error while adding segment',
                placement: 'topRight'
            });
        });

    },

    async segmentReadAll({ commit }, data) {
        commit('segmentReadAllBegin');
        await DataService.get(`/segments?${new URLSearchParams(data).toString()}`).then(response => {
            commit('segmentReadAllSuccess', response.data.data);
        }).catch(err => {
            console.log(err);
            commit('segmentReadAllError', err);
        });
    }
};

export default {
    namespaced: false,
    state,
    actions,
    mutations,
};